import React from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";
import moment from "moment";
import Config from "../../Config";
import {
  SubmitBtn,
  OtherBtn,
  CancelBtn
} from "../Styles/InputStyles";
// import {
//   gTypeOfGame
// } from "../../Config";

const ViewModel = ({ setOpenViewModel, selectedItem, gTypeOfGame }) => {
  //console.log(selectedItem)
  const parseTypeofGames = (values) => {
    if (values == null)
      return 'NA';
    var typeOfGames = '';
    selectedItem?.games.split(',').map((ln, i) => {
      const selectedItem = gTypeOfGame.find(item => item.id == ln);
      if (typeOfGames == '')
        typeOfGames = selectedItem.name;
      else
        typeOfGames = typeOfGames + "," + selectedItem.name;
    })
    //console.log('parserTypeofGames');
    return typeOfGames;
  }
  return (
    <Model width={"w-11/12 max-w-2xl"} setOpenModel={setOpenViewModel}>
      <Wrapper>
        <Title>View Details</Title>
        <SingleItem name={"Bill No"} value={selectedItem?.billId} />
        <SingleItem name={"Bill Date"} value={selectedItem?.creationOn || "NA"} />
        <SingleItem name={"Assoc Name"} value={selectedItem?.assocName} />
        <SingleItem name={"Payer Email"} value={selectedItem?.email} />
        <SingleItem name={"Control Number"} value={ selectedItem?.controlNumber || "NA"} />
        <SingleItem name={"Control Number ExpDate"} value={selectedItem?.controlNumberExpDate || "NA"} />
        <SingleItem name={"Status Remarks"} value={selectedItem?.statusRemarks || "NA"} />
        <SingleItem name={"Amount"} value={selectedItem?.amount + " TZS" || "NA"} />
        <SingleItem name={"Payment Reciept"} value={selectedItem?.paymentReciept || "NA"} />
        <SingleItem name={"Trans. Id"} value={selectedItem?.trxId || "NA"} />
        <SingleItem name={"Trans. Date"} value={selectedItem?.trxDtTm || "NA"} />
        <SingleItem name={"Description"} value={selectedItem?.discription || "NA"} />

        
        
        {selectedItem.constitution && 
          <SingleItem name={"Constitution Doc"} value={ 
          <LinkValue>
          <a  href= {(Config.docUrl + selectedItem.constitution )} target="_blank">Constitution Doc</a>
          </LinkValue>} />
        }
        {selectedItem.mom && 
          <SingleItem name={"Mintue Of Meetings"} value={ 
          <LinkValue>
          <a  href= {(Config.docUrl + selectedItem.mom )} target="_blank">Mintue Of Meetings</a>
          </LinkValue>} />
        }
        {selectedItem.financials && 
          <SingleItem name={"Financial Doc"} value={ 
          <LinkValue>
          <a  href= {(Config.docUrl + selectedItem.financials )} target="_blank">Financials</a>
          </LinkValue>} />
        }
        {selectedItem.principals && 
          <SingleItem name={"Principals Doc"} value={ 
          <LinkValue>
          <a  href= {(Config.docUrl + selectedItem.principals )} target="_blank">Principals Doc</a>
          </LinkValue>} />
        }
        {selectedItem.members && 
          <SingleItem name={"Member's Info"} value={ 
          <LinkValue>
          <a  href= {(Config.docUrl + selectedItem.members )} target="_blank">Member's Info</a>
          </LinkValue>} />
        }
        {selectedItem.certificateName && 
          <SingleItem name={"Certificate"} value={ 
          <LinkValue>
          <a  href= {(Config.docUrl + selectedItem.certificateName )} target="_blank">Download Certificate</a>
          </LinkValue>} />
        }
        {selectedItem.chairmanSignature && 
          <SingleItem name={"Chairman Signature"} value={ 
          // <LinkValue>
          // <a  href= {(Config.docUrl + selectedItem.chairmanSignature )} target="_blank">Chairman Signature</a>
          // </LinkValue>
            <CertificateImage src={(Config.docUrl + selectedItem.chairmanSignature )} />
          } />
        }
        {selectedItem.secretarySignature && 
          <SingleItem name={"Secretary Signature"} value={ 
          // <LinkValue>
          // <a  href= {(Config.docUrl + selectedItem.secretarySignature )} target="_blank">Secretary Signature</a>
          // </LinkValue>} />
          <CertificateImage src={(Config.docUrl + selectedItem.secretarySignature )} />
          } />
        }

      {selectedItem?.isControlNumberFlag == 1 && selectedItem?.status != 2 &&
      <a href={Config.certificateUrl + selectedItem?.assocId + '/' + selectedItem?.controlNumber + ".pdf"} target="_blank" download>
      <BtnWrapper>
          <CancelBtn>Download Bill</CancelBtn>
      </BtnWrapper>
      </a>
      }
      {selectedItem?.status == 2 &&
      <a href={Config.certificateUrl + selectedItem?.assocId + '/' + selectedItem?.controlNumber + "_receipt.pdf"} target="_blank" download>
      <BtnWrapper>
          <CancelBtn>Download Receipt</CancelBtn>
      </BtnWrapper>
      </a>
      }

      
      </Wrapper>
    </Model>
  );
};

const SingleItem = ({ name, value, link, url }) => (
  <div className="flex items-center py-2 border-b border-gray-100 ">
    <Name>{name}</Name> <p className="w-10">:</p>
    {link && (
      <LinkValue href={url} target="_blank" title="Click to open">
        {value}
      </LinkValue>
    )}
    {!link && <Value>{value}</Value>}
  </div>
);

const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl mb-6 text-gray-700 font-medium text-left`;
const Name = tw.p`text-sm text-gray-500  w-40`;
const Value = tw.p`text-sm text-gray-800 font-medium max-w-xs `;
const LinkValue = tw.a`text-sm text-blue-500 max-w-xs truncate cursor-pointer`;
const CertificateImage = tw.img`
w-24 h-12 md:w-24 md:h-12 overflow-hidden bg-gray-100
`;
const BtnWrapper = tw.div` w-full flex items-center justify-end space-x-10 mt-8`;

export default ViewModel;
